<template>
    <div class="dailyTask">
        <div class="headerTabs d-flex align-items-center justify-content-between mb-4">
            <h5 class="f-18 themecolor mb-0">Add/Track</h5>
            <div class="customTabAdd d-flex align-items-center">
                <a href="javascript:void(0)" class="viewTask mr-2" :class="(filter == 'yesterday')?'active':''" @click.prevent="filter = 'yesterday'">Yesterday</a>
                <a href="javascript:void(0)" class="viewTask mr-2" :class="(filter == 'today')?'active':''"  @click.prevent="filter = 'today'">Today</a>
                <!-- <a href="javascript:void(0)" class="viewTask">Tomorrow</a> -->
            </div>
        </div>
            <ul class="add-track-list">
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-meal.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="meal mb-0">Meal</h6>
                            <p class="f-16">Track the time of your first meal</p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)" @click.prevent="addData = 'meal'"><feather type="plus"></feather></a>
                </li>
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-bloodglucose.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="red mb-0">Enter your Blood Glucose</h6>
                            <p class="f-16">80-120/ <span class="mgdl">mg/dL</span></p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)" @click.prevent="addData = 'glucose'"><feather type="plus"></feather></a>
                </li>
                <!-- <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-water.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="themecolor mb-0">Water</h6>
                            <p class="f-16">Drink 8 Glasses of water</p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)"><feather type="plus"></feather></a>
                </li> -->
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-steps.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="item3 mb-0">Steps</h6>
                            <p class="f-16">Take 10,000 steps </p>
                        </div>
                    </div>
                    <p class="f-16 d-flex align-items-center justify-content-between">3600/10,000 </p>
                    <div class="progress">
                      <div class="progress-bar" role="progressbar" style="width: 25%" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100"></div>
                    </div>
                </li>
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-sleep.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="goal-green mb-0">Sleep</h6>
                            <p class="f-16">Track your sleep</p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)" @click.prevent="addData = 'sleep'"><feather type="plus"></feather></a>
                </li>
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-weight.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="rad-alert mb-0">Weight</h6>
                            <p class="f-16">Gain 2.5 kg of weight</p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)" @click.prevent="addData = 'weight'"><feather type="plus"></feather></a>
                </li>
                <li>
                    <div class="media">
                        <img class="mr-3" src="../../../../static/website/images/icon-weight.svg" alt="Image">
                        <div class="media-body">
                            <h6 class="rad-alert mb-0">Blood Pressure</h6>
                            <p class="f-16">125/85</p>
                        </div>
                    </div>
                    <a class="addMore_icon" href="javascript:void(0)" @click.prevent="addData = 'BP'"><feather type="plus"></feather></a>
                </li>
            </ul>

        <!-- Modal Upload-->
        <div class="showModal" v-if="addData == 'meal'">
            <food-intake  :from = "'daily-task'"/>
        </div>
        <div class="showModal" v-if="addData == 'glucose'">
            <glucose-form :from = "'daily-task'" />
        </div>
        <div class="showModal" v-if="addData == 'sleep'">
           <sleep-form :from = "'daily-task'" />
        </div>
        <div class="showModal" v-if="addData == 'weight'">
            <weight-form :from = "'daily-task'" />
        </div>
        <div class="showModal" v-if="addData == 'BP'">
            <bp-form :from = "'daily-task'" />
        </div>
        <!-- End Modal -->
    </div>
</template>
<script>
    import FoodIntake from '../user/forms/food-intake'
    import GlucoseForm from '../user/forms/glucose-level'
    import WeightForm from '../user/forms/weight-data'
    import SleepForm from '../user/forms/sleep-data'
    import BpForm from '../user/forms/BP-data'
    export default {
        name: "Daily-Task",
        data() {
            return {
                tab:'Daily Task',
                addData : '',
                filter : 'today'
            }
        },
        components: {
            FoodIntake,
            GlucoseForm,
            WeightForm,
            SleepForm,
            BpForm
        },
        methods:{
            toggleForm(){
                this.addData = ''
            }
        },
        created(){
            this.pageName('Daily Task')
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/website/goals_and_actions/daily_task.vue